/**
* [Flags]
*/
export var PickerFolders;
(function (PickerFolders) {
    PickerFolders[PickerFolders["None"] = 0] = "None";
    PickerFolders[PickerFolders["Recent"] = 1] = "Recent";
    PickerFolders[PickerFolders["Favorites"] = 2] = "Favorites";
    PickerFolders[PickerFolders["Root"] = 4] = "Root";
    PickerFolders[PickerFolders["Parent"] = 8] = "Parent";
    PickerFolders[PickerFolders["Current"] = 16] = "Current";
    PickerFolders[PickerFolders["DefaultExpand"] = 22] = "DefaultExpand";
    PickerFolders[PickerFolders["Shared"] = 32] = "Shared";
    PickerFolders[PickerFolders["All"] = 64] = "All";
    PickerFolders[PickerFolders["DefaultShow"] = 95] = "DefaultShow";
})(PickerFolders || (PickerFolders = {}));
;
